import { useState } from "react"

export default function useSessionStorage(key, defaultValue) {
  let initialValue = sessionStorage.getItem(key)
  if (initialValue === null) {
    initialValue = defaultValue
  }

  const [value, setStateValue] = useState(initialValue)

  function setStoredValue(newValue) {
    if (newValue === value) return

    setStateValue(newValue)
    sessionStorage.setItem(key, newValue)
  }

  return [value, setStoredValue]
}
